import { Form } from '@tribeplatform/react-components/Form'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { useNetwork, useUpdateNetwork } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

export const PrivacySettings = () => {
  const { $t } = useI18n()
  const { data: network } = useNetwork()
  const { mutateAsync: updateNetwork, isLoading } = useUpdateNetwork()

  return (
    <Card>
      <Card.Header
        title={$t({
          defaultMessage: 'User account deletion option',
          id: 'Admin.Privacy.Settings',
        })}
        description={$t({
          defaultMessage:
            'Enable this to comply with data protection laws and boost user trust by allowing them to delete their account.',
          id: 'Admin.Privacy.Settings.Description',
        })}
      />
      <Card.Content>
        <Form
          defaultValues={{
            settings: {
              memberPermissions: {
                canDeleteAccount:
                  network?.settings?.memberPermissions?.canDeleteAccount,
              },
            },
          }}
          onSubmit={data => {
            updateNetwork({ input: data })
              .then(() => {
                toast({
                  title: $t({
                    defaultMessage: 'User account deletion option updated.',
                    id: 'Admin.Privacy.SettingsUpdated',
                  }),
                  status: 'success',
                })
              })
              .catch(() => {
                toast({
                  title: $t({
                    defaultMessage:
                      'Unable to update user account deletion option',
                    id: 'Admin.Privacy.FailedToUpdateSettings',
                  }),
                  status: 'error',
                })
              })
          }}
        >
          {({ formState }) => {
            return (
              <div className="web:col-span-12 web:md:col-span-8 flex flex-col space-y-5">
                <Form.Toggle
                  name="settings.memberPermissions.canDeleteAccount"
                  label={$t({
                    defaultMessage: 'Allow {MEMBERS} to delete their account',
                    id: 'Admin.Privacy.AllowSelfDeletion',
                  })}
                  description={$t({
                    defaultMessage:
                      '{MEMBERS_CC} will be able to delete their accounts in their account settings. After account deletion, their posts will remain in the community, but their name will be shown as deleted {MEMBER}.',
                    id: 'Admin.Privacy.AllowSelfDeletion.Description',
                  })}
                />
                <Form.Actions>
                  <Button
                    type="submit"
                    loading={isLoading}
                    disabled={!formState.isDirty}
                  >
                    <T defaultMessage="Update" id="Generics.Update" />
                  </Button>
                </Form.Actions>
              </div>
            )
          }}
        </Form>
      </Card.Content>
    </Card>
  )
}
